/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DefaultModal from './DefaultModal';
import Styles from '../../css/modals/CertifyModal.module.css';
import { usePullPayoffContext } from '../../contexts/PullPayoffContext';

const PullPayoffModal = () => {
  const pullPayoffContext = usePullPayoffContext();

  const navigate = useNavigate();

  return (
    <DefaultModal
      open={pullPayoffContext.pullPayoffModalOpen}
      title={''}
      content={
        <section className={Styles.container}>
          <p className={Styles.boldText}>
            A processing fee of $10.00 is applicable to obtain a payoff letter. This fee is charged in accordance with
            the state guidelines.
          </p>
          <p className={Styles.boldText}>Please click "I agree" to proceed further.</p>
        </section>
      }
      footer={
        <div className={Styles.footer}>
          <Button
            variant='contained'
            onClick={() => pullPayoffContext.setPayoffLetterFeeAgreed(true)}
            className={Styles.button}
          >
            I Agree
          </Button>
          <Button variant='contained' onClick={() => navigate(-1)} className={Styles.button}>
            Cancel
          </Button>
        </div>
      }
    />
  );
};

export default PullPayoffModal;
